import type { UpsertRecentUsersMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpsertRecentUsersDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useUpsertRecentUsers = createMutationHook({
  // Per-user UI preference — cannot change any register's row count, so it
  // skips the collapsed nav-badge refetch (COI-908). Without this every column
  // reorder or recent-user write would run all 26 counts.
  invalidatesNavCounts: false,
  name: 'upsertRecentUsers',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.userSearchPreferences.upsertRecentUsers.mutationOptions({
      onSuccess,
    }),
  mapInput: (RecentUserIds: string[]) => ({ RecentUserIds }),
  invalidate: (trpc) => [
    trpc.frontend.userSearchPreferences.getUserSearchPreferences.queryKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): UpsertRecentUsersMutation => ({
    insert_user_search_preferences: {
      __typename: 'user_search_preferences_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: UpsertRecentUsersDocument,
  graphqlVariables: (RecentUserIds) => ({ RecentUserIds }),
  evictFields: ['user_search_preferences'],
});
